<template>
    <article :id="`location-${location.id}`" class="location-card-horizontal">
        <div class="container">
            <div v-show="location?.locationLabel" class="location-city page-label">{{ location.locationLabel }}</div>
            <div class="location-card-horizontal--grid">
                <div class="location-information">
                    <h5 class="location-title">{{ location.title }}</h5>
                    <div class="location-description">
                        <p v-html="nl2br(props.location.locationExcerpt)" />
                    </div>
                    <div v-if="location?.linkUrl?.length && location?.linkUrl[0].linkUrl !== null" class="location-buttons">
                        <UiLink :link="location.linkUrl[0]" :style="'transparent w-border'" />
                    </div>

                    <div class="location-map">
                        <NuxtLink
                            v-if="location.locationRoute"
                            class="location-route"
                            title="Route"
                            :to="location.locationRoute?.url"
                            :external="true"
                            target="_blank"
                        >
                            <UiSvgArrowLeft />
                        </NuxtLink>

                        <div ref="$map" class="map-obj" />
                    </div>
                </div>
                <div class="location-contact">
                    <div class="contact-line">
                        <div class="line-title">{{ $t('location.label_address') }}</div>
                        <div class="line-value">{{ location.locationAddress }}</div>
                    </div>
                    <div class="contact-line">
                        <div class="line-title">{{ $t('location.label_email') }}</div>
                        <div class="line-value">
                            <NuxtLink
                                class="elle-animated-link elle-animated-link-flash"
                                :to="`mailto:${location.locationEmail}`"
                                :title="location.locationEmail"
                                >{{ location.locationEmail }}</NuxtLink
                            >
                        </div>
                    </div>
                    <div v-for="item in location.locationContact" :key="item.id" class="contact-line">
                        <div class="line-title">{{ item.label }}</div>
                        <div class="line-value">
                            <div class="content typography" v-html="item.body" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        location?: CmsItem;
    }>(),
    {
        location: () => ({})
    }
);

const runtimeConfig = useRuntimeConfig();
const location = computed(() => props.location);
const $map = ref<HTMLDivElement | null>(null);
const { onLoaded } = useScriptGoogleMaps({
    apiKey: runtimeConfig.public.apiMap,
    language: 'nl-NL'
});

const [lat = 0, lng = 0] = (location.value?.locationPosition as string | undefined)?.split(',').map((item: string) => parseFloat(item.trim())) ?? [
    0, 0
];

onMounted(() => {
    onLoaded(async instance => {
        const maps = (await instance.maps) as any;
        if ($map.value) {
            const objMap = new maps.Map($map.value, {
                center: {
                    lat,
                    lng
                },
                styles: googleMapStyle(),
                disableDefaultUI: true,
                zoom: 15
            });
            new maps.Marker({
                position: {
                    lat,
                    lng
                },
                map: objMap,
                title: location.value.title,
                animation: maps.Animation.DROP
            });
        }
    });
});

onUnmounted(() => {
    $map.value = null;
});
</script>
